import { AnalyticsSender } from '@funtech-int/yango-shared';

import { serialStructureMovieImpressionNavigated } from '@kinopoisk-int/evgen-web-events/web/serial_structure';

interface SeriesStructureAnalytics {
    episodeClicked(this: void, seriesId: string, seasonNumber: number, seriesTitle: string): void;
}

export function createSeriesStructureAnalytics(
    eventSender: AnalyticsSender
): SeriesStructureAnalytics {
    return {
        episodeClicked(seriesId, seasonNumber, seriesTitle) {
            const selectionName =
                seriesTitle && seasonNumber ? `${seriesTitle}_season_${seasonNumber}` : '-';
            eventSender.send(serialStructureMovieImpressionNavigated, {
                uuid: seriesId ?? '-',
                title: seriesTitle ?? '-',
                selectionName: selectionName ?? '-',
            });
        },
    };
}
